import StickersAPI from '@/API/my-menu/stickers-api'

export default {
  namespaced: true,
  state: {
    stickers: [],
    allStickers: [],
    stickersFetched: false,
    stickersLoading: false,
  },

  getters: {
    stickers: (state: any) => state.stickers,
    stickersFetched: (state: any) => state.stickersFetched,
    allStickers: (state: any) => state.allStickers,
  },

  mutations: {
    SET_STICKERS(state: any, stickers: any) {
      state.stickers = stickers
      state.stickersFetched = true
    },
    SET_ALL_STICKERS(state: any, stickers: any) {
      state.allStickers = stickers
      state.stickersFetched = true
    },
    TRIGGER_LOADER(state: any, loader: boolean) {
      state.stickersLoading = loader
    },
    SET_STICKERS_FETCHED(state: any, fetched: boolean) {
      state.stickersFetched = fetched
    },
  },

  actions: {
    async FETCH_STICKERS(context: any, { force = false, businessId = null }) {
      if (context.state.stickersLoading) {
        return []
      }
      if (context.state.stickersFetched && !force) {
        return context.state.stickers
      }
      context.commit('TRIGGER_LOADER', true)
      try {
        const currentBusinessTypeId = businessId ?? context.rootGetters['auth/user']?.businessType?.id
        const { stickers, all } = await StickersAPI.index(currentBusinessTypeId)
        context.commit('SET_STICKERS', stickers)
        context.commit('SET_ALL_STICKERS', all)
      } catch (err) {
        console.error(err)
      } finally {
        context.commit('TRIGGER_LOADER', false)
      }
      return context.state.stickers
    },
    async PUSH_STICKER(context: any, sticker: any) {
      const stickers = [...context.state.allStickers]
      stickers.unshift(sticker)
      context.commit('SET_ALL_STICKERS', stickers)
    },
  },
}
